import { licenses } from "@/lib/constants/licenses";
import { CurrentUser } from "@rumble-it/common-lib/types/models/CurrentUser.interface";
/**
 * licensesAvailableToUser is a filtered list of licenses
 * that are available to the user based on their features
 * and permissions.
 */
export const getLicensesByCurrentUser = (currentUser: CurrentUser | null) => {
  if (!currentUser) {
    return [];
  }

  return licenses.filter((license) => {
    // Returns false if the license does not match any of the user's features
    if (
      license.matchesFeatures &&
      !license.matchesFeatures.some((feature) =>
        currentUser?.affiliateFeatureTypes?.includes(feature),
      )
    ) {
      return false;
    }

    // Return false if the license does not match any of the user's permissions
    if (
      license.matchesPermissions &&
      !license.matchesPermissions.some((permission) =>
        currentUser?.permissions?.includes(permission),
      )
    ) {
      return false;
    }

    return true;
  });
};
